module.exports = __webpack_public_path__ + "static/media/Si-Road_white.066a66af.png";